import{createContext as r,useContext as o}from"react";var t=r(!1),e=t.Provider;function i(){return o(t)}export{e as IsInsideIsolatedDcAppProvider,i as useIsInsideIsolatedDcApp};
